import React, { useContext } from 'react';
import {
  Field,
  withSitecoreContext,
  RichText,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { APIWebstoreContext } from '../../context/globalContext';

type MonogramVerifonePaymentConfirmationProps = {
  fields?: {
    Title: Field<string>;
    ConfirmationText: Field<string>;
  };
};

type ComponentProps = MonogramVerifonePaymentConfirmationProps & WithSitecoreContextProps;

const MonogramVerifonePaymentConfirmation = ({ fields }: ComponentProps): JSX.Element => {
  const { state } = useContext(APIWebstoreContext);

  function replaceText(): Field<string> | undefined {
    if (!fields?.ConfirmationText?.value) {
      return undefined;
    }

    const paymentConfirmationText = fields.ConfirmationText.value.replace(
      '##INVOICE_NUMBER##',
      state?.lastOrderId || ''
    );

    return {
      ...fields.ConfirmationText,
      value: paymentConfirmationText,
    };
  }

  const replacedField = replaceText();

  return (
    <div className="monogram-verifone-payment">
      <div className="orderConfirmationSection">
        <div className="orderConfirmationHeader">
          <h1>{fields?.Title?.value}</h1>
        </div>
        <div className="orderConfirmationContent">
          {replacedField && (
            <RichText className="orderConfirmationRichText" field={replacedField} />
          )}
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(MonogramVerifonePaymentConfirmation);
